import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DatePipe, NgClass, NgIf, NgTemplateOutlet } from '@angular/common';
import { ProductDetailViewModel } from '@models/api-search.models';
import { StoreViewModel } from '@models/api.models';
import { StoreStockSidebarType } from '@features/store-stock/store-stock';
import { StoreStockDetailedComponent } from '@features/store-stock/store-stock-detailed/store-stock-detailed.component';
import { TranslateSafePipe } from '@shared/translate-safe/translate-safe.pipe';
import { FormatStringPipe } from '@shared/format-string/format-string.pipe';
import { SvgIconComponent } from '@shared/svg-icon/svg-icon.component';
import { ImageComponent } from '@shared/image/image/image.component';
import { TooltipComponent } from '@shared/tooltip/tooltip.component';

@Component({
    selector: 'app-store-stock-list-item',
    templateUrl: './store-stock-list-item.component.html',
    styleUrls: ['./store-stock-list-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgIf,
        ImageComponent,
        SvgIconComponent,
        NgClass,
        StoreStockDetailedComponent,
        DatePipe,
        FormatStringPipe,
        TranslateSafePipe,
        TooltipComponent,
        NgTemplateOutlet
    ]
})
export class StoreStockListItemComponent {
    @Input()
    store: StoreViewModel;

    @Input()
    product?: ProductDetailViewModel;

    @Input()
    type: StoreStockSidebarType = 'select';

    @Input()
    isFavorite: boolean = false;

    @Output()
    handleClick = new EventEmitter<void>();
}
